import {keyMap, modifier} from '@/common/shortcuts/constants';

// eslint-disable-next-line max-len
export const getCode = x => keyMap[x.toLowerCase()] || modifier[x.toLowerCase()]
    || x.toUpperCase().charCodeAt(0);

export const parseCode = (e) => {
    const evt = e || event;
    let code = evt.keyCode || evt.which || evt.charCode;
    // Gecko(Firefox)
    if (code === 93 || code === 224) {
        code = 91;
    }
    return code;
};
